/**
 * @license lucide-react v0.475.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["polygon", {
  points: "6 3 20 12 6 21 6 3",
  key: "1oa8hb"
}]];
var Play = createLucideIcon("Play", __iconNode);
export { __iconNode, Play as default };